var cov_7qnzho1tx = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/flat.ts",
      hash = "6de97c70567217d5669379fe156b6e9085e1e312",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/flat.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 14
        },
        end: {
          line: 7,
          column: 27
        }
      },
      "1": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 8,
          column: 76
        }
      },
      "2": {
        start: {
          line: 8,
          column: 40
        },
        end: {
          line: 8,
          column: 75
        }
      },
      "3": {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 15,
          column: 32
        }
      },
      "4": {
        start: {
          line: 15,
          column: 21
        },
        end: {
          line: 15,
          column: 32
        }
      },
      "5": {
        start: {
          line: 16,
          column: 25
        },
        end: {
          line: 16,
          column: 27
        }
      },
      "6": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 49,
          column: 5
        }
      },
      "7": {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 27,
          column: 7
        }
      },
      "8": {
        start: {
          line: 26,
          column: 8
        },
        end: {
          line: 26,
          column: 26
        }
      },
      "9": {
        start: {
          line: 28,
          column: 11
        },
        end: {
          line: 49,
          column: 5
        }
      },
      "10": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 35,
          column: 7
        }
      },
      "11": {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 30,
          column: 25
        }
      },
      "12": {
        start: {
          line: 32,
          column: 8
        },
        end: {
          line: 34,
          column: 9
        }
      },
      "13": {
        start: {
          line: 33,
          column: 10
        },
        end: {
          line: 33,
          column: 60
        }
      },
      "14": {
        start: {
          line: 37,
          column: 18
        },
        end: {
          line: 37,
          column: 22
        }
      },
      "15": {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 48,
          column: 7
        }
      },
      "16": {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 43,
          column: 9
        }
      },
      "17": {
        start: {
          line: 41,
          column: 10
        },
        end: {
          line: 41,
          column: 23
        }
      },
      "18": {
        start: {
          line: 42,
          column: 10
        },
        end: {
          line: 42,
          column: 72
        }
      },
      "19": {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 47,
          column: 9
        }
      },
      "20": {
        start: {
          line: 46,
          column: 10
        },
        end: {
          line: 46,
          column: 27
        }
      },
      "21": {
        start: {
          line: 51,
          column: 2
        },
        end: {
          line: 51,
          column: 19
        }
      },
      "22": {
        start: {
          line: 52,
          column: 2
        },
        end: {
          line: 52,
          column: 15
        }
      },
      "23": {
        start: {
          line: 56,
          column: 2
        },
        end: {
          line: 58,
          column: 3
        }
      },
      "24": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 18
        }
      },
      "25": {
        start: {
          line: 60,
          column: 23
        },
        end: {
          line: 60,
          column: 37
        }
      },
      "26": {
        start: {
          line: 62,
          column: 25
        },
        end: {
          line: 62,
          column: 27
        }
      },
      "27": {
        start: {
          line: 72,
          column: 2
        },
        end: {
          line: 88,
          column: 6
        }
      },
      "28": {
        start: {
          line: 75,
          column: 28
        },
        end: {
          line: 75,
          column: 42
        }
      },
      "29": {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 76,
          column: 18
        }
      },
      "30": {
        start: {
          line: 77,
          column: 6
        },
        end: {
          line: 77,
          column: 15
        }
      },
      "31": {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 78,
          column: 14
        }
      },
      "32": {
        start: {
          line: 79,
          column: 6
        },
        end: {
          line: 86,
          column: 24
        }
      },
      "33": {
        start: {
          line: 80,
          column: 8
        },
        end: {
          line: 80,
          column: 46
        }
      },
      "34": {
        start: {
          line: 81,
          column: 8
        },
        end: {
          line: 81,
          column: 74
        }
      },
      "35": {
        start: {
          line: 82,
          column: 8
        },
        end: {
          line: 82,
          column: 40
        }
      },
      "36": {
        start: {
          line: 83,
          column: 8
        },
        end: {
          line: 83,
          column: 56
        }
      },
      "37": {
        start: {
          line: 84,
          column: 8
        },
        end: {
          line: 84,
          column: 38
        }
      },
      "38": {
        start: {
          line: 85,
          column: 8
        },
        end: {
          line: 85,
          column: 22
        }
      },
      "39": {
        start: {
          line: 87,
          column: 6
        },
        end: {
          line: 87,
          column: 36
        }
      },
      "40": {
        start: {
          line: 89,
          column: 2
        },
        end: {
          line: 89,
          column: 46
        }
      },
      "41": {
        start: {
          line: 96,
          column: 2
        },
        end: {
          line: 109,
          column: 6
        }
      },
      "42": {
        start: {
          line: 97,
          column: 17
        },
        end: {
          line: 97,
          column: 44
        }
      },
      "43": {
        start: {
          line: 102,
          column: 18
        },
        end: {
          line: 102,
          column: 95
        }
      },
      "44": {
        start: {
          line: 103,
          column: 20
        },
        end: {
          line: 103,
          column: 31
        }
      },
      "45": {
        start: {
          line: 104,
          column: 16
        },
        end: {
          line: 104,
          column: 59
        }
      },
      "46": {
        start: {
          line: 105,
          column: 6
        },
        end: {
          line: 105,
          column: 27
        }
      },
      "47": {
        start: {
          line: 105,
          column: 21
        },
        end: {
          line: 105,
          column: 27
        }
      },
      "48": {
        start: {
          line: 106,
          column: 22
        },
        end: {
          line: 106,
          column: 57
        }
      },
      "49": {
        start: {
          line: 107,
          column: 6
        },
        end: {
          line: 107,
          column: 39
        }
      },
      "50": {
        start: {
          line: 107,
          column: 18
        },
        end: {
          line: 107,
          column: 39
        }
      },
      "51": {
        start: {
          line: 108,
          column: 6
        },
        end: {
          line: 108,
          column: 19
        }
      },
      "52": {
        start: {
          line: 110,
          column: 19
        },
        end: {
          line: 110,
          column: 60
        }
      },
      "53": {
        start: {
          line: 111,
          column: 2
        },
        end: {
          line: 113,
          column: 4
        }
      },
      "54": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 112,
          column: 55
        }
      },
      "55": {
        start: {
          line: 112,
          column: 35
        },
        end: {
          line: 112,
          column: 55
        }
      },
      "56": {
        start: {
          line: 121,
          column: 16
        },
        end: {
          line: 123,
          column: 11
        }
      },
      "57": {
        start: {
          line: 122,
          column: 17
        },
        end: {
          line: 122,
          column: 58
        }
      },
      "58": {
        start: {
          line: 125,
          column: 2
        },
        end: {
          line: 144,
          column: 4
        }
      },
      "59": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 126,
          column: 55
        }
      },
      "60": {
        start: {
          line: 126,
          column: 49
        },
        end: {
          line: 126,
          column: 55
        }
      },
      "61": {
        start: {
          line: 128,
          column: 4
        },
        end: {
          line: 131,
          column: 5
        }
      },
      "62": {
        start: {
          line: 129,
          column: 6
        },
        end: {
          line: 129,
          column: 32
        }
      },
      "63": {
        start: {
          line: 130,
          column: 6
        },
        end: {
          line: 130,
          column: 12
        }
      },
      "64": {
        start: {
          line: 133,
          column: 16
        },
        end: {
          line: 133,
          column: 93
        }
      },
      "65": {
        start: {
          line: 134,
          column: 18
        },
        end: {
          line: 134,
          column: 29
        }
      },
      "66": {
        start: {
          line: 135,
          column: 14
        },
        end: {
          line: 135,
          column: 57
        }
      },
      "67": {
        start: {
          line: 136,
          column: 4
        },
        end: {
          line: 136,
          column: 25
        }
      },
      "68": {
        start: {
          line: 136,
          column: 19
        },
        end: {
          line: 136,
          column: 25
        }
      },
      "69": {
        start: {
          line: 137,
          column: 4
        },
        end: {
          line: 140,
          column: 5
        }
      },
      "70": {
        start: {
          line: 138,
          column: 6
        },
        end: {
          line: 138,
          column: 19
        }
      },
      "71": {
        start: {
          line: 139,
          column: 6
        },
        end: {
          line: 139,
          column: 12
        }
      },
      "72": {
        start: {
          line: 141,
          column: 20
        },
        end: {
          line: 141,
          column: 55
        }
      },
      "73": {
        start: {
          line: 142,
          column: 4
        },
        end: {
          line: 142,
          column: 25
        }
      },
      "74": {
        start: {
          line: 143,
          column: 4
        },
        end: {
          line: 143,
          column: 17
        }
      },
      "75": {
        start: {
          line: 147,
          column: 23
        },
        end: {
          line: 151,
          column: 1
        }
      },
      "76": {
        start: {
          line: 148,
          column: 2
        },
        end: {
          line: 148,
          column: 44
        }
      },
      "77": {
        start: {
          line: 148,
          column: 32
        },
        end: {
          line: 148,
          column: 44
        }
      },
      "78": {
        start: {
          line: 149,
          column: 17
        },
        end: {
          line: 149,
          column: 42
        }
      },
      "79": {
        start: {
          line: 150,
          column: 2
        },
        end: {
          line: 150,
          column: 47
        }
      },
      "80": {
        start: {
          line: 156,
          column: 28
        },
        end: {
          line: 174,
          column: 1
        }
      },
      "81": {
        start: {
          line: 157,
          column: 2
        },
        end: {
          line: 157,
          column: 39
        }
      },
      "82": {
        start: {
          line: 157,
          column: 20
        },
        end: {
          line: 157,
          column: 39
        }
      },
      "83": {
        start: {
          line: 159,
          column: 20
        },
        end: {
          line: 159,
          column: 37
        }
      },
      "84": {
        start: {
          line: 160,
          column: 2
        },
        end: {
          line: 160,
          column: 26
        }
      },
      "85": {
        start: {
          line: 162,
          column: 2
        },
        end: {
          line: 168,
          column: 4
        }
      },
      "86": {
        start: {
          line: 163,
          column: 18
        },
        end: {
          line: 163,
          column: 49
        }
      },
      "87": {
        start: {
          line: 165,
          column: 4
        },
        end: {
          line: 165,
          column: 50
        }
      },
      "88": {
        start: {
          line: 165,
          column: 15
        },
        end: {
          line: 165,
          column: 50
        }
      },
      "89": {
        start: {
          line: 166,
          column: 4
        },
        end: {
          line: 167,
          column: 27
        }
      },
      "90": {
        start: {
          line: 166,
          column: 16
        },
        end: {
          line: 166,
          column: 34
        }
      },
      "91": {
        start: {
          line: 167,
          column: 9
        },
        end: {
          line: 167,
          column: 27
        }
      },
      "92": {
        start: {
          line: 171,
          column: 2
        },
        end: {
          line: 171,
          column: 80
        }
      },
      "93": {
        start: {
          line: 171,
          column: 39
        },
        end: {
          line: 171,
          column: 80
        }
      },
      "94": {
        start: {
          line: 173,
          column: 2
        },
        end: {
          line: 173,
          column: 15
        }
      },
      "95": {
        start: {
          line: 176,
          column: 31
        },
        end: {
          line: 185,
          column: 1
        }
      },
      "96": {
        start: {
          line: 177,
          column: 16
        },
        end: {
          line: 177,
          column: 43
        }
      },
      "97": {
        start: {
          line: 178,
          column: 2
        },
        end: {
          line: 184,
          column: 3
        }
      },
      "98": {
        start: {
          line: 179,
          column: 4
        },
        end: {
          line: 179,
          column: 57
        }
      },
      "99": {
        start: {
          line: 181,
          column: 4
        },
        end: {
          line: 183,
          column: 6
        }
      },
      "100": {
        start: {
          line: 182,
          column: 6
        },
        end: {
          line: 182,
          column: 51
        }
      },
      "101": {
        start: {
          line: 182,
          column: 35
        },
        end: {
          line: 182,
          column: 51
        }
      },
      "102": {
        start: {
          line: 187,
          column: 29
        },
        end: {
          line: 188,
          column: 103
        }
      },
      "103": {
        start: {
          line: 188,
          column: 2
        },
        end: {
          line: 188,
          column: 103
        }
      },
      "104": {
        start: {
          line: 188,
          column: 29
        },
        end: {
          line: 188,
          column: 97
        }
      }
    },
    fnMap: {
      "0": {
        name: "insertPoint",
        decl: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 6,
            column: 27
          }
        },
        loc: {
          start: {
            line: 6,
            column: 42
          },
          end: {
            line: 9,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 8,
            column: 27
          },
          end: {
            line: 8,
            column: 28
          }
        },
        loc: {
          start: {
            line: 8,
            column: 40
          },
          end: {
            line: 8,
            column: 75
          }
        },
        line: 8
      },
      "2": {
        name: "flatten",
        decl: {
          start: {
            line: 14,
            column: 16
          },
          end: {
            line: 14,
            column: 23
          }
        },
        loc: {
          start: {
            line: 14,
            column: 59
          },
          end: {
            line: 53,
            column: 1
          }
        },
        line: 14
      },
      "3": {
        name: "recurse",
        decl: {
          start: {
            line: 17,
            column: 11
          },
          end: {
            line: 17,
            column: 18
          }
        },
        loc: {
          start: {
            line: 17,
            column: 53
          },
          end: {
            line: 50,
            column: 3
          }
        },
        line: 17
      },
      "4": {
        name: "unflatten",
        decl: {
          start: {
            line: 55,
            column: 16
          },
          end: {
            line: 55,
            column: 25
          }
        },
        loc: {
          start: {
            line: 55,
            column: 52
          },
          end: {
            line: 90,
            column: 1
          }
        },
        line: 55
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 74,
            column: 13
          },
          end: {
            line: 74,
            column: 14
          }
        },
        loc: {
          start: {
            line: 74,
            column: 18
          },
          end: {
            line: 88,
            column: 5
          }
        },
        line: 74
      },
      "6": {
        name: "insertValue",
        decl: {
          start: {
            line: 95,
            column: 16
          },
          end: {
            line: 95,
            column: 27
          }
        },
        loc: {
          start: {
            line: 95,
            column: 88
          },
          end: {
            line: 114,
            column: 1
          }
        },
        line: 95
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 97,
            column: 12
          },
          end: {
            line: 97,
            column: 13
          }
        },
        loc: {
          start: {
            line: 97,
            column: 17
          },
          end: {
            line: 97,
            column: 44
          }
        },
        line: 97
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 100,
            column: 13
          },
          end: {
            line: 100,
            column: 14
          }
        },
        loc: {
          start: {
            line: 100,
            column: 18
          },
          end: {
            line: 109,
            column: 5
          }
        },
        line: 100
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 111,
            column: 32
          },
          end: {
            line: 111,
            column: 33
          }
        },
        loc: {
          start: {
            line: 111,
            column: 37
          },
          end: {
            line: 113,
            column: 3
          }
        },
        line: 111
      },
      "10": {
        name: "spliceValue",
        decl: {
          start: {
            line: 120,
            column: 16
          },
          end: {
            line: 120,
            column: 27
          }
        },
        loc: {
          start: {
            line: 120,
            column: 95
          },
          end: {
            line: 145,
            column: 1
          }
        },
        line: 120
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 122,
            column: 12
          },
          end: {
            line: 122,
            column: 13
          }
        },
        loc: {
          start: {
            line: 122,
            column: 17
          },
          end: {
            line: 122,
            column: 58
          }
        },
        line: 122
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 125,
            column: 16
          },
          end: {
            line: 125,
            column: 17
          }
        },
        loc: {
          start: {
            line: 125,
            column: 21
          },
          end: {
            line: 144,
            column: 3
          }
        },
        line: 125
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 147,
            column: 23
          },
          end: {
            line: 147,
            column: 24
          }
        },
        loc: {
          start: {
            line: 147,
            column: 55
          },
          end: {
            line: 151,
            column: 1
          }
        },
        line: 147
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 156,
            column: 28
          },
          end: {
            line: 156,
            column: 29
          }
        },
        loc: {
          start: {
            line: 156,
            column: 77
          },
          end: {
            line: 174,
            column: 1
          }
        },
        line: 156
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 162,
            column: 26
          },
          end: {
            line: 162,
            column: 27
          }
        },
        loc: {
          start: {
            line: 162,
            column: 54
          },
          end: {
            line: 168,
            column: 3
          }
        },
        line: 162
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 176,
            column: 31
          },
          end: {
            line: 176,
            column: 32
          }
        },
        loc: {
          start: {
            line: 176,
            column: 79
          },
          end: {
            line: 185,
            column: 1
          }
        },
        line: 176
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 181,
            column: 32
          },
          end: {
            line: 181,
            column: 33
          }
        },
        loc: {
          start: {
            line: 181,
            column: 37
          },
          end: {
            line: 183,
            column: 5
          }
        },
        line: 181
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 187,
            column: 29
          },
          end: {
            line: 187,
            column: 30
          }
        },
        loc: {
          start: {
            line: 188,
            column: 2
          },
          end: {
            line: 188,
            column: 103
          }
        },
        line: 188
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 188,
            column: 14
          },
          end: {
            line: 188,
            column: 15
          }
        },
        loc: {
          start: {
            line: 188,
            column: 29
          },
          end: {
            line: 188,
            column: 97
          }
        },
        line: 188
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 8,
            column: 53
          },
          end: {
            line: 8,
            column: 74
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 8,
            column: 63
          },
          end: {
            line: 8,
            column: 64
          }
        }, {
          start: {
            line: 8,
            column: 67
          },
          end: {
            line: 8,
            column: 74
          }
        }],
        line: 8
      },
      "1": {
        loc: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 15,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 15,
            column: 32
          }
        }, {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 15,
            column: 32
          }
        }],
        line: 15
      },
      "2": {
        loc: {
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        }, {
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        }],
        line: 18
      },
      "3": {
        loc: {
          start: {
            line: 19,
            column: 6
          },
          end: {
            line: 23,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 6
          },
          end: {
            line: 19,
            column: 25
          }
        }, {
          start: {
            line: 20,
            column: 6
          },
          end: {
            line: 20,
            column: 31
          }
        }, {
          start: {
            line: 21,
            column: 6
          },
          end: {
            line: 21,
            column: 25
          }
        }, {
          start: {
            line: 22,
            column: 6
          },
          end: {
            line: 22,
            column: 26
          }
        }, {
          start: {
            line: 23,
            column: 7
          },
          end: {
            line: 23,
            column: 16
          }
        }, {
          start: {
            line: 23,
            column: 20
          },
          end: {
            line: 23,
            column: 38
          }
        }],
        line: 19
      },
      "4": {
        loc: {
          start: {
            line: 25,
            column: 6
          },
          end: {
            line: 27,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 25,
            column: 6
          },
          end: {
            line: 27,
            column: 7
          }
        }, {
          start: {
            line: 25,
            column: 6
          },
          end: {
            line: 27,
            column: 7
          }
        }],
        line: 25
      },
      "5": {
        loc: {
          start: {
            line: 25,
            column: 12
          },
          end: {
            line: 25,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 12
          },
          end: {
            line: 25,
            column: 29
          }
        }, {
          start: {
            line: 25,
            column: 33
          },
          end: {
            line: 25,
            column: 64
          }
        }],
        line: 25
      },
      "6": {
        loc: {
          start: {
            line: 28,
            column: 11
          },
          end: {
            line: 49,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 11
          },
          end: {
            line: 49,
            column: 5
          }
        }, {
          start: {
            line: 28,
            column: 11
          },
          end: {
            line: 49,
            column: 5
          }
        }],
        line: 28
      },
      "7": {
        loc: {
          start: {
            line: 29,
            column: 6
          },
          end: {
            line: 35,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 29,
            column: 6
          },
          end: {
            line: 35,
            column: 7
          }
        }, {
          start: {
            line: 29,
            column: 6
          },
          end: {
            line: 35,
            column: 7
          }
        }],
        line: 29
      },
      "8": {
        loc: {
          start: {
            line: 33,
            column: 26
          },
          end: {
            line: 33,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 33,
            column: 33
          },
          end: {
            line: 33,
            column: 48
          }
        }, {
          start: {
            line: 33,
            column: 51
          },
          end: {
            line: 33,
            column: 59
          }
        }],
        line: 33
      },
      "9": {
        loc: {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 48,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 48,
            column: 7
          }
        }, {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 48,
            column: 7
          }
        }],
        line: 38
      },
      "10": {
        loc: {
          start: {
            line: 42,
            column: 46
          },
          end: {
            line: 42,
            column: 71
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 42,
            column: 53
          },
          end: {
            line: 42,
            column: 67
          }
        }, {
          start: {
            line: 42,
            column: 70
          },
          end: {
            line: 42,
            column: 71
          }
        }],
        line: 42
      },
      "11": {
        loc: {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 47,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 47,
            column: 9
          }
        }, {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 47,
            column: 9
          }
        }],
        line: 45
      },
      "12": {
        loc: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        }, {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        }],
        line: 56
      },
      "13": {
        loc: {
          start: {
            line: 56,
            column: 6
          },
          end: {
            line: 56,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 6
          },
          end: {
            line: 56,
            column: 33
          }
        }, {
          start: {
            line: 56,
            column: 37
          },
          end: {
            line: 56,
            column: 53
          }
        }, {
          start: {
            line: 56,
            column: 57
          },
          end: {
            line: 56,
            column: 79
          }
        }],
        line: 56
      },
      "14": {
        loc: {
          start: {
            line: 81,
            column: 45
          },
          end: {
            line: 81,
            column: 73
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 81,
            column: 58
          },
          end: {
            line: 81,
            column: 61
          }
        }, {
          start: {
            line: 81,
            column: 64
          },
          end: {
            line: 81,
            column: 73
          }
        }],
        line: 81
      },
      "15": {
        loc: {
          start: {
            line: 83,
            column: 14
          },
          end: {
            line: 83,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 83,
            column: 14
          },
          end: {
            line: 83,
            column: 23
          }
        }, {
          start: {
            line: 83,
            column: 28
          },
          end: {
            line: 83,
            column: 55
          }
        }],
        line: 83
      },
      "16": {
        loc: {
          start: {
            line: 83,
            column: 40
          },
          end: {
            line: 83,
            column: 55
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 83,
            column: 48
          },
          end: {
            line: 83,
            column: 50
          }
        }, {
          start: {
            line: 83,
            column: 53
          },
          end: {
            line: 83,
            column: 55
          }
        }],
        line: 83
      },
      "17": {
        loc: {
          start: {
            line: 84,
            column: 15
          },
          end: {
            line: 84,
            column: 38
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 84,
            column: 23
          },
          end: {
            line: 84,
            column: 31
          }
        }, {
          start: {
            line: 84,
            column: 34
          },
          end: {
            line: 84,
            column: 38
          }
        }],
        line: 84
      },
      "18": {
        loc: {
          start: {
            line: 105,
            column: 6
          },
          end: {
            line: 105,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 105,
            column: 6
          },
          end: {
            line: 105,
            column: 27
          }
        }, {
          start: {
            line: 105,
            column: 6
          },
          end: {
            line: 105,
            column: 27
          }
        }],
        line: 105
      },
      "19": {
        loc: {
          start: {
            line: 107,
            column: 6
          },
          end: {
            line: 107,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 107,
            column: 6
          },
          end: {
            line: 107,
            column: 39
          }
        }, {
          start: {
            line: 107,
            column: 6
          },
          end: {
            line: 107,
            column: 39
          }
        }],
        line: 107
      },
      "20": {
        loc: {
          start: {
            line: 112,
            column: 4
          },
          end: {
            line: 112,
            column: 55
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 112,
            column: 4
          },
          end: {
            line: 112,
            column: 55
          }
        }, {
          start: {
            line: 112,
            column: 4
          },
          end: {
            line: 112,
            column: 55
          }
        }],
        line: 112
      },
      "21": {
        loc: {
          start: {
            line: 122,
            column: 17
          },
          end: {
            line: 122,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 122,
            column: 17
          },
          end: {
            line: 122,
            column: 27
          }
        }, {
          start: {
            line: 122,
            column: 31
          },
          end: {
            line: 122,
            column: 58
          }
        }],
        line: 122
      },
      "22": {
        loc: {
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 126,
            column: 55
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 126,
            column: 55
          }
        }, {
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 126,
            column: 55
          }
        }],
        line: 126
      },
      "23": {
        loc: {
          start: {
            line: 126,
            column: 8
          },
          end: {
            line: 126,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 126,
            column: 8
          },
          end: {
            line: 126,
            column: 18
          }
        }, {
          start: {
            line: 126,
            column: 22
          },
          end: {
            line: 126,
            column: 47
          }
        }],
        line: 126
      },
      "24": {
        loc: {
          start: {
            line: 128,
            column: 4
          },
          end: {
            line: 131,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 128,
            column: 4
          },
          end: {
            line: 131,
            column: 5
          }
        }, {
          start: {
            line: 128,
            column: 4
          },
          end: {
            line: 131,
            column: 5
          }
        }],
        line: 128
      },
      "25": {
        loc: {
          start: {
            line: 136,
            column: 4
          },
          end: {
            line: 136,
            column: 25
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 136,
            column: 4
          },
          end: {
            line: 136,
            column: 25
          }
        }, {
          start: {
            line: 136,
            column: 4
          },
          end: {
            line: 136,
            column: 25
          }
        }],
        line: 136
      },
      "26": {
        loc: {
          start: {
            line: 137,
            column: 4
          },
          end: {
            line: 140,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 137,
            column: 4
          },
          end: {
            line: 140,
            column: 5
          }
        }, {
          start: {
            line: 137,
            column: 4
          },
          end: {
            line: 140,
            column: 5
          }
        }],
        line: 137
      },
      "27": {
        loc: {
          start: {
            line: 148,
            column: 2
          },
          end: {
            line: 148,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 148,
            column: 2
          },
          end: {
            line: 148,
            column: 44
          }
        }, {
          start: {
            line: 148,
            column: 2
          },
          end: {
            line: 148,
            column: 44
          }
        }],
        line: 148
      },
      "28": {
        loc: {
          start: {
            line: 157,
            column: 2
          },
          end: {
            line: 157,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 157,
            column: 2
          },
          end: {
            line: 157,
            column: 39
          }
        }, {
          start: {
            line: 157,
            column: 2
          },
          end: {
            line: 157,
            column: 39
          }
        }],
        line: 157
      },
      "29": {
        loc: {
          start: {
            line: 165,
            column: 4
          },
          end: {
            line: 165,
            column: 50
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 165,
            column: 4
          },
          end: {
            line: 165,
            column: 50
          }
        }, {
          start: {
            line: 165,
            column: 4
          },
          end: {
            line: 165,
            column: 50
          }
        }],
        line: 165
      },
      "30": {
        loc: {
          start: {
            line: 166,
            column: 4
          },
          end: {
            line: 167,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 166,
            column: 4
          },
          end: {
            line: 167,
            column: 27
          }
        }, {
          start: {
            line: 166,
            column: 4
          },
          end: {
            line: 167,
            column: 27
          }
        }],
        line: 166
      },
      "31": {
        loc: {
          start: {
            line: 171,
            column: 2
          },
          end: {
            line: 171,
            column: 80
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 171,
            column: 2
          },
          end: {
            line: 171,
            column: 80
          }
        }, {
          start: {
            line: 171,
            column: 2
          },
          end: {
            line: 171,
            column: 80
          }
        }],
        line: 171
      },
      "32": {
        loc: {
          start: {
            line: 171,
            column: 6
          },
          end: {
            line: 171,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 171,
            column: 6
          },
          end: {
            line: 171,
            column: 13
          }
        }, {
          start: {
            line: 171,
            column: 17
          },
          end: {
            line: 171,
            column: 37
          }
        }],
        line: 171
      },
      "33": {
        loc: {
          start: {
            line: 178,
            column: 2
          },
          end: {
            line: 184,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 178,
            column: 2
          },
          end: {
            line: 184,
            column: 3
          }
        }, {
          start: {
            line: 178,
            column: 2
          },
          end: {
            line: 184,
            column: 3
          }
        }],
        line: 178
      },
      "34": {
        loc: {
          start: {
            line: 182,
            column: 6
          },
          end: {
            line: 182,
            column: 51
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 182,
            column: 6
          },
          end: {
            line: 182,
            column: 51
          }
        }, {
          start: {
            line: 182,
            column: 6
          },
          end: {
            line: 182,
            column: 51
          }
        }],
        line: 182
      },
      "35": {
        loc: {
          start: {
            line: 188,
            column: 29
          },
          end: {
            line: 188,
            column: 97
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 188,
            column: 50
          },
          end: {
            line: 188,
            column: 79
          }
        }, {
          start: {
            line: 188,
            column: 82
          },
          end: {
            line: 188,
            column: 97
          }
        }],
        line: 188
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0, 0, 0, 0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _defineProperty from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread2 from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
// https://stackoverflow.com/questions/19098797/fastest-way-to-flatten-un-flatten-nested-json-objects
import { isEmpty, isObject } from './is';
import { deepClone } from './clone';
export function insertPoint(name) {
  cov_7qnzho1tx.f[0]++;
  var reg = (cov_7qnzho1tx.s[0]++, /(\[\d+\])/gi);
  cov_7qnzho1tx.s[1]++;
  return name.replace(reg, function (s, m, i) {
    cov_7qnzho1tx.f[1]++;
    cov_7qnzho1tx.s[2]++;
    return s.replace(m, i === 0 ? (cov_7qnzho1tx.b[0][0]++, m) : (cov_7qnzho1tx.b[0][1]++, ".".concat(m)));
  });
}
export function flatten(data, skipArray) {
  cov_7qnzho1tx.f[2]++;
  cov_7qnzho1tx.s[3]++;

  if (isEmpty(data)) {
    cov_7qnzho1tx.b[1][0]++;
    cov_7qnzho1tx.s[4]++;
    return data;
  } else {
    cov_7qnzho1tx.b[1][1]++;
  }

  var result = (cov_7qnzho1tx.s[5]++, {});

  function recurse(cur, prop) {
    cov_7qnzho1tx.f[3]++;
    cov_7qnzho1tx.s[6]++;

    if ((cov_7qnzho1tx.b[3][0]++, Object(cur) !== cur) || (cov_7qnzho1tx.b[3][1]++, typeof cur === 'function') || (cov_7qnzho1tx.b[3][2]++, cur instanceof Date) || (cov_7qnzho1tx.b[3][3]++, cur instanceof Error) || (cov_7qnzho1tx.b[3][4]++, skipArray) && (cov_7qnzho1tx.b[3][5]++, Array.isArray(cur))) {
      cov_7qnzho1tx.b[2][0]++;
      cov_7qnzho1tx.s[7]++;

      if (!((cov_7qnzho1tx.b[5][0]++, cur === undefined) && (cov_7qnzho1tx.b[5][1]++, /\[\d+\]$/.test(prop)))) {
        cov_7qnzho1tx.b[4][0]++;
        cov_7qnzho1tx.s[8]++;
        result[prop] = cur;
      } else {
        cov_7qnzho1tx.b[4][1]++;
      }
    } else {
      cov_7qnzho1tx.b[2][1]++;
      cov_7qnzho1tx.s[9]++;

      if (Array.isArray(cur)) {
        cov_7qnzho1tx.b[6][0]++;
        cov_7qnzho1tx.s[10]++;

        if (cur.length === 0) {
          cov_7qnzho1tx.b[7][0]++;
          cov_7qnzho1tx.s[11]++;
          result[prop] = [];
        } else {
          cov_7qnzho1tx.b[7][1]++;
          cov_7qnzho1tx.s[12]++;

          for (var i = 0, l = cur.length; i < l; i++) {
            cov_7qnzho1tx.s[13]++;
            recurse(cur[i], prop ? (cov_7qnzho1tx.b[8][0]++, "".concat(prop, "[").concat(i, "]")) : (cov_7qnzho1tx.b[8][1]++, "[".concat(i, "]")));
          }
        }
      } else {
        cov_7qnzho1tx.b[6][1]++;
        var empty = (cov_7qnzho1tx.s[14]++, true);
        cov_7qnzho1tx.s[15]++;

        if (typeof cur === 'object') {
          cov_7qnzho1tx.b[9][0]++;
          cov_7qnzho1tx.s[16]++;

          // eslint-disable-next-line
          for (var p in cur) {
            cov_7qnzho1tx.s[17]++;
            empty = false;
            cov_7qnzho1tx.s[18]++;
            recurse(cur[p], prop ? (cov_7qnzho1tx.b[10][0]++, "".concat(prop, ".").concat(p)) : (cov_7qnzho1tx.b[10][1]++, p));
          }

          cov_7qnzho1tx.s[19]++;

          if (empty) {
            cov_7qnzho1tx.b[11][0]++;
            cov_7qnzho1tx.s[20]++;
            result[prop] = {};
          } else {
            cov_7qnzho1tx.b[11][1]++;
          }
        } else {
          cov_7qnzho1tx.b[9][1]++;
        }
      }
    }
  }

  cov_7qnzho1tx.s[21]++;
  recurse(data, '');
  cov_7qnzho1tx.s[22]++;
  return result;
}
export function unflatten(rawdata) {
  cov_7qnzho1tx.f[4]++;
  cov_7qnzho1tx.s[23]++;

  if ((cov_7qnzho1tx.b[13][0]++, Object(rawdata) !== rawdata) || (cov_7qnzho1tx.b[13][1]++, isEmpty(rawdata)) || (cov_7qnzho1tx.b[13][2]++, Array.isArray(rawdata))) {
    cov_7qnzho1tx.b[12][0]++;
    cov_7qnzho1tx.s[24]++;
    return rawdata;
  } else {
    cov_7qnzho1tx.b[12][1]++;
  }

  var data = (cov_7qnzho1tx.s[25]++, _objectSpread2({}, rawdata));
  var result = (cov_7qnzho1tx.s[26]++, {}); // let { cur, prop, idx, last, temp, match } = {}

  var cur;
  var prop;
  var idx;
  var last;
  var temp;
  var match; // eslint-disable-next-line

  cov_7qnzho1tx.s[27]++;
  Object.keys(data).sort().forEach(function (p) {
    cov_7qnzho1tx.f[5]++;
    var pathWithPoint = (cov_7qnzho1tx.s[28]++, insertPoint(p));
    cov_7qnzho1tx.s[29]++;
    cur = result;
    cov_7qnzho1tx.s[30]++;
    prop = '';
    cov_7qnzho1tx.s[31]++;
    last = 0;
    cov_7qnzho1tx.s[32]++;

    do {
      cov_7qnzho1tx.s[33]++;
      idx = pathWithPoint.indexOf('.', last);
      cov_7qnzho1tx.s[34]++;
      temp = pathWithPoint.substring(last, idx !== -1 ? (cov_7qnzho1tx.b[14][0]++, idx) : (cov_7qnzho1tx.b[14][1]++, undefined));
      cov_7qnzho1tx.s[35]++;
      match = /^\[(\d+)\]$/.exec(temp);
      cov_7qnzho1tx.s[36]++;
      cur = (cov_7qnzho1tx.b[15][0]++, cur[prop]) || (cov_7qnzho1tx.b[15][1]++, cur[prop] = match ? (cov_7qnzho1tx.b[16][0]++, []) : (cov_7qnzho1tx.b[16][1]++, {}));
      cov_7qnzho1tx.s[37]++;
      prop = match ? (cov_7qnzho1tx.b[17][0]++, match[1]) : (cov_7qnzho1tx.b[17][1]++, temp);
      cov_7qnzho1tx.s[38]++;
      last = idx + 1;
    } while (idx >= 0);

    cov_7qnzho1tx.s[39]++;
    cur[prop] = deepClone(data[p]);
  });
  cov_7qnzho1tx.s[40]++;
  return result[''];
}
export function insertValue(obj, name, index, value) {
  cov_7qnzho1tx.f[6]++;
  cov_7qnzho1tx.s[41]++;
  Object.keys(obj).filter(function (n) {
    cov_7qnzho1tx.f[7]++;
    cov_7qnzho1tx.s[42]++;
    return n.indexOf("".concat(name, "[")) === 0;
  }).sort().reverse().forEach(function (n) {
    cov_7qnzho1tx.f[8]++;
    // const reg = new RegExp(`${name}\\[(\\d+)\\]`)
    var reg = (cov_7qnzho1tx.s[43]++, new RegExp("".concat(name.replace(/\[/g, '\\[').replace(/\]/g, '\\]'), "\\[(\\d+)\\]")));
    var match = (cov_7qnzho1tx.s[44]++, reg.exec(n));
    var i = (cov_7qnzho1tx.s[45]++, parseInt(match[1], 10));
    cov_7qnzho1tx.s[46]++;

    if (i < index) {
      cov_7qnzho1tx.b[18][0]++;
      cov_7qnzho1tx.s[47]++;
      return;
    } else {
      cov_7qnzho1tx.b[18][1]++;
    }

    var newName = (cov_7qnzho1tx.s[48]++, n.replace(reg, "".concat(name, "[").concat(i + 1, "]")));
    cov_7qnzho1tx.s[49]++;

    if (obj[n]) {
      cov_7qnzho1tx.b[19][0]++;
      cov_7qnzho1tx.s[50]++;
      obj[newName] = obj[n];
    } else {
      cov_7qnzho1tx.b[19][1]++;
    }

    cov_7qnzho1tx.s[51]++;
    delete obj[n];
  });
  var newValue = (cov_7qnzho1tx.s[52]++, flatten(_defineProperty({}, "".concat(name, "[").concat(index, "]"), value)));
  cov_7qnzho1tx.s[53]++;
  Object.keys(newValue).forEach(function (k) {
    cov_7qnzho1tx.f[9]++;
    cov_7qnzho1tx.s[54]++;

    if (newValue[k] !== undefined) {
      cov_7qnzho1tx.b[20][0]++;
      cov_7qnzho1tx.s[55]++;
      obj[k] = newValue[k];
    } else {
      cov_7qnzho1tx.b[20][1]++;
    }
  });
}
export function spliceValue(obj, name, index) {
  cov_7qnzho1tx.f[10]++;
  var names = (cov_7qnzho1tx.s[56]++, Object.keys(obj).filter(function (n) {
    cov_7qnzho1tx.f[11]++;
    cov_7qnzho1tx.s[57]++;
    return (cov_7qnzho1tx.b[21][0]++, n === name) || (cov_7qnzho1tx.b[21][1]++, n.indexOf("".concat(name, "[")) === 0);
  }).sort());
  cov_7qnzho1tx.s[58]++;
  names.forEach(function (n) {
    cov_7qnzho1tx.f[12]++;
    cov_7qnzho1tx.s[59]++;

    if ((cov_7qnzho1tx.b[23][0]++, n === name) && (cov_7qnzho1tx.b[23][1]++, !Array.isArray(obj[name]))) {
      cov_7qnzho1tx.b[22][0]++;
      cov_7qnzho1tx.s[60]++;
      return;
    } else {
      cov_7qnzho1tx.b[22][1]++;
    }

    cov_7qnzho1tx.s[61]++;

    if (n === name) {
      cov_7qnzho1tx.b[24][0]++;
      cov_7qnzho1tx.s[62]++;
      obj[name].splice(index, 1);
      cov_7qnzho1tx.s[63]++;
      return;
    } else {
      cov_7qnzho1tx.b[24][1]++;
    }

    var reg = (cov_7qnzho1tx.s[64]++, new RegExp("".concat(name.replace(/\[/g, '\\[').replace(/\]/g, '\\]'), "\\[(\\d+)\\]")));
    var match = (cov_7qnzho1tx.s[65]++, reg.exec(n));
    var i = (cov_7qnzho1tx.s[66]++, parseInt(match[1], 10));
    cov_7qnzho1tx.s[67]++;

    if (i < index) {
      cov_7qnzho1tx.b[25][0]++;
      cov_7qnzho1tx.s[68]++;
      return;
    } else {
      cov_7qnzho1tx.b[25][1]++;
    }

    cov_7qnzho1tx.s[69]++;

    if (i === index) {
      cov_7qnzho1tx.b[26][0]++;
      cov_7qnzho1tx.s[70]++;
      delete obj[n];
      cov_7qnzho1tx.s[71]++;
      return;
    } else {
      cov_7qnzho1tx.b[26][1]++;
    }

    var newName = (cov_7qnzho1tx.s[72]++, n.replace(reg, "".concat(name, "[").concat(i - 1, "]")));
    cov_7qnzho1tx.s[73]++;
    obj[newName] = obj[n];
    cov_7qnzho1tx.s[74]++;
    delete obj[n];
  });
}
cov_7qnzho1tx.s[75]++;

var isNameWithPath = function isNameWithPath(name, path) {
  cov_7qnzho1tx.f[13]++;
  cov_7qnzho1tx.s[76]++;

  if (name.indexOf(path) !== 0) {
    cov_7qnzho1tx.b[27][0]++;
    cov_7qnzho1tx.s[77]++;
    return false;
  } else {
    cov_7qnzho1tx.b[27][1]++;
  }

  var remain = (cov_7qnzho1tx.s[78]++, name.replace(path, '')[0]);
  cov_7qnzho1tx.s[79]++;
  return [undefined, '[', '.'].includes(remain);
};

cov_7qnzho1tx.s[80]++;
export var getSthByName = function getSthByName(name, source) {
  cov_7qnzho1tx.f[14]++;
  cov_7qnzho1tx.s[81]++;

  if (source[name]) {
    cov_7qnzho1tx.b[28][0]++;
    cov_7qnzho1tx.s[82]++;
    return source[name];
  } else {
    cov_7qnzho1tx.b[28][1]++;
  }

  var result = (cov_7qnzho1tx.s[83]++, unflatten(source));
  cov_7qnzho1tx.s[84]++;
  name = insertPoint(name);
  cov_7qnzho1tx.s[85]++;
  name.split('.').forEach(function (n) {
    cov_7qnzho1tx.f[15]++;
    var match = (cov_7qnzho1tx.s[86]++, /^\[(\d+)\]$/.exec(n)); // eslint-disable-next-line

    cov_7qnzho1tx.s[87]++;

    if (match) {
      cov_7qnzho1tx.b[29][0]++;
      cov_7qnzho1tx.s[88]++;
      n = match[1];
    } else {
      cov_7qnzho1tx.b[29][1]++;
    }

    cov_7qnzho1tx.s[89]++;

    if (result) {
      cov_7qnzho1tx.b[30][0]++;
      cov_7qnzho1tx.s[90]++;
      result = result[n];
    } else {
      cov_7qnzho1tx.b[30][1]++;
      cov_7qnzho1tx.s[91]++;
      result = undefined;
    }
  }); // get from form-error

  cov_7qnzho1tx.s[92]++;

  if ((cov_7qnzho1tx.b[32][0]++, !result) && (cov_7qnzho1tx.b[32][1]++, isObject(source['']))) {
    cov_7qnzho1tx.b[31][0]++;
    cov_7qnzho1tx.s[93]++;
    result = source[''][name];
  } else {
    cov_7qnzho1tx.b[31][1]++;
  }

  cov_7qnzho1tx.s[94]++;
  return result;
};
cov_7qnzho1tx.s[95]++;
export var removeSthByName = function removeSthByName(name, source) {
  cov_7qnzho1tx.f[16]++;
  var match = (cov_7qnzho1tx.s[96]++, /(.*)\[(\d+)\]$/.exec(name));
  cov_7qnzho1tx.s[97]++;

  if (match) {
    cov_7qnzho1tx.b[33][0]++;
    cov_7qnzho1tx.s[98]++;
    spliceValue(source, match[1], parseInt(match[2], 10));
  } else {
    cov_7qnzho1tx.b[33][1]++;
    cov_7qnzho1tx.s[99]++;
    Object.keys(source).forEach(function (n) {
      cov_7qnzho1tx.f[17]++;
      cov_7qnzho1tx.s[100]++;

      if (isNameWithPath(n, name)) {
        cov_7qnzho1tx.b[34][0]++;
        cov_7qnzho1tx.s[101]++;
        delete source[n];
      } else {
        cov_7qnzho1tx.b[34][1]++;
      }
    });
  }
};
cov_7qnzho1tx.s[102]++;
export var flattenArray = function flattenArray(arr1) {
  cov_7qnzho1tx.f[18]++;
  cov_7qnzho1tx.s[103]++;
  return arr1.reduce(function (acc, val) {
    cov_7qnzho1tx.f[19]++;
    cov_7qnzho1tx.s[104]++;
    return Array.isArray(val) ? (cov_7qnzho1tx.b[35][0]++, acc.concat(flattenArray(val))) : (cov_7qnzho1tx.b[35][1]++, acc.concat(val));
  }, []);
};